import React from 'react';
import cn from 'classnames';
import CompanyItem from 'components/CompanyItem';

import styles from './JobResults.module.scss';

export default function JobResults(props) {
  return (
    <React.Fragment>
      <div className={cn(styles.root, 'job-results')}>
        <div className={styles.flex_col}>
          <h1 className={styles.title}>Searches</h1>

          <div className={styles.grid}>
            <div className={styles.grid__cell}>
              <div className={styles.content_box}>
                <CompanyItem
                  highlights={`Marketing Director`}
                  image={require('assets/131b0c8b59b1371cb552e673203e4286.png')}
                />
              </div>
            </div>
            <div className={styles.grid__cell}>
              <div className={styles.content_box}>
                <CompanyItem
                  highlights={`General Marketing`}
                  image={require('assets/8747e0575d861a02a357d095d657501e.png')}
                />
              </div>
            </div>
            <div className={styles.grid__cell1}>
              <div className={styles.content_box1}>
                <CompanyItem
                  highlights={`Marketing LATAM`}
                  image={require('assets/cef30a20730e99a28797caa70f814f35.png')}
                />
              </div>
            </div>
            <div className={styles.grid__cell}>
              <div className={styles.content_box1}>
                <CompanyItem highlights={`CMO`} image={require('assets/17acbe9f1540ed7d8da42fcff935e2a2.png')} />
              </div>
            </div>
            <div className={styles.grid__cell1}>
              <div className={styles.content_box1}>
                <CompanyItem highlights={`CMO`} image={require('assets/096abf892f7ca900dd2c8af492371b79.png')} />
              </div>
            </div>
            <div className={styles.grid__cell}>
              <div className={styles.content_box1}>
                <CompanyItem highlights={`Marketing `} image={require('assets/0ae6f1a1106d5c96e14aa350807c2f10.png')} />
              </div>
            </div>
            <div className={styles.grid__cell1}>
              <div className={styles.content_box1}>
                <CompanyItem
                  highlights={`Marketing Director`}
                  image={require('assets/739df968f2e3f502c921864e8d258858.png')}
                />
              </div>
            </div>
            <div className={styles.grid__cell}>
              <div className={styles.content_box1}>
                <CompanyItem
                  highlights={`Marketing Manager`}
                  image={require('assets/26ddb7d79d25bb8efc89bcaa8f622f75.png')}
                />
              </div>
            </div>
            <div className={styles.grid__cell1}>
              <div className={styles.content_box1}>
                <CompanyItem
                  highlights={`Marketing US`}
                  image={require('assets/6befa73b742c2ad892d415a0e71510a5.png')}
                />
              </div>
            </div>
            <div className={styles.grid__cell}>
              <div className={styles.content_box1}>
                <CompanyItem highlights={`CMO`} image={require('assets/6a988e4e51a7c582d342bb577a7c359b.png')} />
              </div>
            </div>
            <div className={styles.grid__cell1}>
              <div className={styles.content_box1}>
                <CompanyItem
                  highlights={`Marketing IN`}
                  image={require('assets/ab12b1a09e41b79133ae68f3073b3f29.png')}
                />
              </div>
            </div>
            <div className={styles.grid__cell}>
              <div className={styles.content_box1}>
                <CompanyItem highlights={`Marketing`} image={require('assets/6e1b0b00ed0731faa1bac3cf0de380de.png')} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
